/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Keen_Dove_GlideInputs */

const en_soft_keen_dove_glide = /** @type {(inputs: Soft_Keen_Dove_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallback language`)
};

const de_soft_keen_dove_glide = /** @type {(inputs: Soft_Keen_Dove_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersatzsprache`)
};

/**
* | output |
* | --- |
* | "Fallback language" |
*
* @param {Soft_Keen_Dove_GlideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_keen_dove_glide = /** @type {((inputs?: Soft_Keen_Dove_GlideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Keen_Dove_GlideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_keen_dove_glide(inputs)
	return de_soft_keen_dove_glide(inputs)
});